const languages = {
  en: {
    iso: 'en',
    short: 'EN',
    long: 'English',
    sbe: 'en',
    adGlare: 'en_gb',
  },
  tc: {
    iso: 'zh-hk',
    short: '繁',
    long: '繁體中文',
    sbe: 'zh',
    adGlare: 'zh_hant',
  },
  sc: {
    iso: 'zh-cn',
    short: '简',
    long: '简体中文',
    sbe: 'cn',
    adGlare: 'zh_hans',
  },
  ar: {
    iso: 'ar',
    short: 'AR',
    long: 'Arabic',
    sbe: 'ar',
    adGlare: 'ar',
  },
};

export default languages;
